import { stripIndent } from "common-tags";
import { AbandonedCheckout } from "./components/AbandonedCheckout";

export const abandonedCheckoutEmailTemplate = {
    label: 'Abandoned Checkout',
    description: 'Sent when a customer abandons their checkout',
    icon: 'ShoppingCart',
    component: AbandonedCheckout,
    defaultTemplate: {
        name: 'Abandoned Checkout',
        subject: {
            en: 'Complete your purchase at {{ storeName }}',
            fr: 'Complétez votre achat sur {{ storeName }}',
            it: 'Completa il tuo acquisto su {{ storeName }}',
            es: 'Completa tu compra en {{ storeName }}',
            de: 'Schließe deinen Einkauf bei {{ storeName }} ab',
        },
        templateVariables: {
            abandoned_checkout: {
                // prettier-ignore
                body: {
                    en: stripIndent`<p>Hello {{ customerFirstName }},</p>
             <p>We noticed you left some items in your cart. Would you like to complete your purchase?</p>
             <p>Click the button below to return to your cart.</p>`,
                    fr: stripIndent`<p>Bonjour {{ customerFirstName }},</p>
             <p>Nous avons remarqué que vous avez laissé des articles dans votre panier. Souhaitez-vous finaliser votre achat?</p>
             <p>Cliquez sur le bouton ci-dessous pour retourner à votre panier.</p>`,
                    it: stripIndent`<p>Ciao {{ customerFirstName }},</p>
             <p>Abbiamo notato che hai lasciato alcuni articoli nel tuo carrello. Vorresti completare il tuo acquisto?</p>
             <p>Clicca sul pulsante qui sotto per tornare al tuo carrello.</p>`,
                    es: stripIndent`<p>Hola {{ customerFirstName }},</p>
             <p>Hemos notado que dejaste algunos artículos en tu carrito. ¿Te gustaría completar tu compra?</p>
             <p>Haz clic en el botón de abajo para volver a tu carrito.</p>`,
                    de: stripIndent`<p>Hallo {{ customerFirstName }},</p>
             <p>Wir haben bemerkt, dass du einige Artikel in deinem Warenkorb gelassen hast. Möchtest du deinen Einkauf abschließen?</p>
             <p>Klicke auf die Schaltfläche unten, um zu deinem Warenkorb zurückzukehren.</p>`,
                },
            },
        },
    },
    variables: [
        { key: 'customerFirstName', label: 'Customer First Name', example: 'John' },
        { key: 'customerLastName', label: 'Customer Last Name', example: 'Doe' },
        { key: 'customerEmail', label: 'Customer Email', example: 'john@example.com' },
        { key: 'storeName', label: 'Store Name', example: 'My Store' },
        { key: 'cartTotal', label: 'Cart Total', example: '$99.99' },
        { key: 'checkoutUrl', label: 'Checkout URL', example: 'https://...' },
    ],
    utmParameters: {
        utmSource: 'checkout_recovery',
        utmMedium: 'email',
        utmCampaign: 'automatic_abandoned_checkout',
        utmContent: (template: any) =>
            template.params?.specific?.triggerDurationSinceLastActivity || '',
    },
    specificParams: {
        triggerDurationSinceLastActivity: {
            type: 'select',
            label: 'Trigger Duration',
            default: '1h',
            options: [
                { value: '10min', label: '10 minutes' },
                { value: '30min', label: '30 minutes' },
                { value: '1h', label: '1 hour' },
                { value: '3h', label: '3 hours' },
                { value: '6h', label: '6 hours' },
                { value: '12h', label: '12 hours' },
                { value: '24h', label: '24 hours' },
                { value: '48h', label: '48 hours' },
            ],
        },
    },
    defaultMessages: {
        checkout_title: 'Complete your purchase',
        checkout_subtitle: 'Your cart is waiting for you',
        informations_title: 'Order Information',
        cart_title: 'Cart Summary',
        cta_button: 'Return to Cart',
        footer_text: '© 2024 All rights reserved',
    },
}